import React from "react";
import "./Hero.css";
import Header from "./Header/Header";
import hero_image from "../assets/hero_image.png";
import hero_image_back from "../assets/hero_image_back.png";
import heart from "../assets/heart.png";
import calories from "../assets/calories.png";
import { motion } from "framer-motion";
import NumberCounter from "number-counter";
import { Link } from "react-scroll";
// import { useEffect } from "react";

const Hero = () => {
  const transition = { duration: 3, type: "spring" };
  const mobile = window.innerWidth <= 768 ? true : false;
  // useEffect(() => {
  //   const b = document.querySelector("best-ad::before");
  //   b.style = { color: "var(--orange)", left: "20px" };
  // });
  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="hero-l">
        <Header />
        {/* the best ad  */}
        <div className="best-ad">
          <motion.div
            initial={{ left: mobile ? "178px" : "238px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          ></motion.div>
          <span>THE BEST FITNESS CLUB IN THE TOWN</span>
        </div>
        {/* Hero heading  */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>
          <div>
            <span> Ideal body</span>
          </div>
          <div className="text">
            In here we will help you to shape and build your ideal body and live
            up your life to fullest
          </div>
        </div>
        <div className="figures">
          <div>
            <span>
              <div>
                <NumberCounter end={140} start={100} delay={4} preFix="+" />
              </div>
            </span>
            <span>expert coaches</span>
          </div>
          <div>
            <span>
              <div>
                <NumberCounter end={978} start={878} delay={4} preFix="+" />
              </div>
            </span>
            <span>Members joined</span>
          </div>
          <div>
            <span>
              <div>
                <NumberCounter end={50} delay={2} preFix="+" />{" "}
              </div>
            </span>
            <span>fitness programs</span>
          </div>
        </div>
        {/* Buttons  */}
        <div className="buttons">
          <button className="btn">Get Started</button>
          <button className="btn">Learn More</button>
        </div>
      </div>
      {/* Right side */}
      <div className="hero-r">
        <button className="btn">
          <Link to="join" smooth={true}>
            Join Now
          </Link>
        </button>
        <motion.div
          className="heart-rate"
          initial={{ right: "-1rem" }}
          whileInView={{ right: "4rem" }}
          transition={transition}
        >
          <img src={heart} alt="heart" className="heart" />
          <img src={hero_image_back} alt="heart" className="hero_image_back" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>

        {/* hero images */}
        <img src={hero_image} alt="Hero Image" className="hero_image" />
        <motion.div
          className="stats"
          initial={{ right: "32rem" }}
          whileInView={{ right: "28rem" }}
          transition={transition}
        >
          <img src={calories} alt="calories" className="calories" />
          <div>
            <span>Calories burned</span>
            <span>220 kcal </span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
